/// <amd-module name="Wit/Portal/Redux/WorkItemPortalReducers" />
import produce from "immer";
import { WorkItemPortalActionTypes, WorkItemPortalActions } from "./WorkItemPortalActions";
import { defaultWorkItemPortalState, IWorkItemPortalState } from "./WorkItemPortalContracts";

/**
 * Reducers for work item creation actions for new work items
 */
export function workItemPortalReducer(state: IWorkItemPortalState, action: WorkItemPortalActions): IWorkItemPortalState {
    return produce(state || defaultWorkItemPortalState, draft => {
        switch (action.type) {
            case WorkItemPortalActionTypes.ShowWorkItem: {
                const { workItem } = action.payload;
                draft.workItemQueue.push(workItem);
                break;
            }
            case WorkItemPortalActionTypes.CloseWorkItem: {
                const { workItemId } = action.payload;
                const index = draft.workItemQueue.findIndex(workItem => workItem.workItemId === workItemId);
                if (index >= 0) {
                    draft.workItemQueue.splice(index, 1);
                }
                break;
            }
        }
    });
}
